// Simple seeded random number generator
function seededRandom(seed: number): () => number {
  let m = 0x80000000; // 2**31
  let a = 1103515245;
  let c = 12345;

  let state = seed;

  return function () {
    state = (a * state + c) % m;
    return state / m;
  };
}

export function getRandomItems<T>(array: T[], numItems: number): T[] {
  if (numItems >= array.length) {
    return array; // Return the whole array if numItems is greater than or equal to the array length
  }

  // Generate a random seed using Math.random()
  const seed = Math.floor(Math.random() * 1000000);

  // Create the seeded random function
  const random = seededRandom(seed);

  // Make a copy of the array to avoid modifying the original array
  const shuffledArray = array.slice();

  // Shuffle the array using Fisher-Yates algorithm with seeded random
  for (let i = shuffledArray.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1));
    [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
  }

  // Return the first `numItems` items from the shuffled array
  return shuffledArray.slice(0, numItems);
}

// Fisher–Yates shuffle returning a NEW array with all items in random order.
// Unlike getRandomItems(list, list.length) — which early-returns the original
// order unchanged — this always randomizes, used to keep the home carousel fresh.
export function shuffle<T>(array: T[]): T[] {
  const result = array.slice();
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}

// Repeat items (cycling) until the array has at least `min` entries. Keeps the
// marquee track wide enough to fill the viewport when only a few playlists exist.
// Returns a copy unchanged when already long enough; empty stays empty.
export function padToMinLength<T>(items: T[], min: number): T[] {
  if (items.length === 0 || items.length >= min) {
    return items.slice();
  }
  const result: T[] = [];
  while (result.length < min) {
    result.push(items[result.length % items.length]);
  }
  return result;
}
